import { registerError } from '@adornis/baseql/metadata/register.js';
import { ActionTokenDataInvalidError } from './ActionTokenDataInvalidError.js';
import { ActionTokenDataNotFoundError } from './ActionTokenDataNotFoundError.js';
import { BlockSignoffDaysInAdvanceError } from './BlockSignoffDaysInAdvanceError.js';
import { ExportError } from './ExportError.js';
import { ImportError } from './ImportError.js';
import { InvalidInstitutionIDError } from './InvalidInstitutionIDError.js';
import { NoParticipantsAvailableError } from './NoParticipantsAvailableError.js';
import { PasswordNotValidError } from './PasswordNotValidError.js';
import { QRCodeExpiredError, QRCodeInvalidError, QRCodeNotValidYetError } from './QRCodeInvalidError.js';
import { QRCodeNoParticipationError } from './QRCodeNoParticipationError.js';
import { RegistrationAlreadyDoneError } from './RegistrationAlreadyDoneError.js';
import { RegistrationAuthorizationNeededError } from './RegistrationAuthorizationNeededError.js';
import { RegistrationCollisionsError } from './RegistrationCollisionError.js';
import { RegistrationInternalServerError } from './RegistrationInternalServerError.js';
import { RegistrationInvalidError } from './RegistrationInvalidError.js';
import { RegistrationLdapNeededError } from './RegistrationLdapNeededError.js';
import { RegistrationMaintenanceError } from './RegistrationMaintenanceError.js';
import { RegistrationPaymentNeededError } from './RegistrationPaymentNeededError.js';
import { RegistrationSuspendedError } from './RegistrationSuspendedError.js';
import { RegistrationTooManyAttemptsError } from './RegistrationTooManyAttemptsError.js';
import { RegistrationWrongCodeError } from './RegistrationWrongCodeError.js';
import { TimeslotsAreoverlappingError } from './TimeslotsAreoverlappingError.js';
import { UserNotFoundError } from './UserNotFoundError.js';

export const registerAllBHErrors = () => {
  // register errors
  registerError(BlockSignoffDaysInAdvanceError);
  registerError(TimeslotsAreoverlappingError);
  registerError(QRCodeInvalidError);
  registerError(QRCodeNotValidYetError);
  registerError(QRCodeExpiredError);
  registerError(QRCodeNoParticipationError);

  // registration errors
  registerError(RegistrationAuthorizationNeededError);
  registerError(RegistrationWrongCodeError);
  registerError(NoParticipantsAvailableError);
  registerError(RegistrationTooManyAttemptsError);
  registerError(RegistrationPaymentNeededError);
  registerError(RegistrationAlreadyDoneError);
  registerError(RegistrationInvalidError);
  registerError(RegistrationLdapNeededError);
  registerError(RegistrationCollisionsError);
  registerError(RegistrationSuspendedError);
  registerError(RegistrationMaintenanceError);
  registerError(InvalidInstitutionIDError);
  registerError(RegistrationInternalServerError);

  // actionTokenData errors
  registerError(ActionTokenDataNotFoundError);
  registerError(ActionTokenDataInvalidError);

  // other errors
  registerError(PasswordNotValidError);
  registerError(UserNotFoundError);

  // import export
  registerError(ImportError);
  registerError(ExportError);
};
